import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Button, Typography, Alert } from "@mui/material";
import { useParams } from "react-router-dom";
import ChatInterface from "./ChatInterface"; // Import the ChatInterface component

const ScheduledChat = () => {
  const [isStartEnabled, setIsStartEnabled] = useState(false);
  const [showChat, setShowChat] = useState(false); // State to manage chat visibility
  const { jobId, resumeId } = useParams();
  const baseURL = "https://hr.aiassistant.co:8443/api/v1/";

  useEffect(() => {
    const fetchCandidateSlot = async () => {
      try {
        const response = await axios.get(
          `${baseURL}candidate_slot/${jobId}/${resumeId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const startTimeGMT = new Date(response.data.time_slot.start_time); // Scheduled start time in GMT
        const currentDateTimeGMT = new Date(new Date().toISOString()); // Current date & time converted to GMT

        console.log("Scheduled Start:", startTimeGMT);
        console.log("Current DateTime (GMT):", currentDateTimeGMT);

        // Enable the Start button if the current GMT time is past the scheduled start time
        if (currentDateTimeGMT >= startTimeGMT) {
          setIsStartEnabled(true);
        } else {
          setIsStartEnabled(false);
        }
      } catch (error) {
        console.error("Failed to fetch candidate slot:", error);
      }
    };

    fetchCandidateSlot();
  }, [jobId, resumeId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        backgroundColor: "#f9f9f9",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        display="flex"
        justifyContent="center"
        style={{
          fontFamily: "Montserrat",
          fontWeight: 700,
          textAlign: "left",
          color: "#202224",
          gap: "0px",
          opacity: 0.8,
        }}
      >
        Chat Interface
      </Typography>

      {/* Conditionally render the start button */}
      {!showChat && (
        <Button
          variant="contained"
          color="primary"
          disabled={!isStartEnabled}
          onClick={() => setShowChat(true)} // Show the chat when clicked
          sx={{
            marginTop: "20px",
            padding: "10px 20px",
            fontSize: "16px",
          }}
        >
          Start
        </Button>
      )}
      {/* Display a message if the scheduled start time is not reached */}
      {!isStartEnabled && (
        <Alert
          severity="info"
          sx={{ margin: "20px", width: "50%", justifyContent: "center" }}
        >
          Your scheduled time has not been reached. Please wait until your
          scheduled time to start the chat.
        </Alert>
      )}

      {/* Conditionally render the chat interface with increased width */}
      {showChat && (
        <Box
          sx={{
            width: "100%", 
            marginTop: "15px",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <ChatInterface jobId={jobId} resumeId={resumeId} />
        </Box>
      )}
    </Box>
  );
};

export default ScheduledChat;
